import { Component, Prop } from 'vue-property-decorator';
import * as tsx from 'vue-tsx-support';
import './styles.less'

interface WinThePrizeProps {
    visible: boolean;
    close: () => void;
    success: (verification: string) => void
}

@Component
export default class Captcha extends tsx.Component<WinThePrizeProps> {

    @Prop() public visible!: boolean
    @Prop() public close!: () => void
    @Prop() public success!: (verification: string) => void


    constructor(props: any) {
        super(props)
    }
    mounted() {
        window.addEventListener('message',(e) =>{
            console.log(e.data)
            if (e.data.type === 'close') {
                this.$props.close()
            }
            if (e.data.type === 'success') {
                this.$props.success(e.data.captchaVerification)
            }
        },false)
    }

    render() {
        return this.$props.visible ? (
            <div  class='captchaBox'>
                <iframe  src="/captcha/index.html" frameborder="0"></iframe>
            </div>
        ) : null
    }

}
